const AttendanceTable = ({ data, loading }) => {

  if (loading) {
    return (
      <div className="bg-white border rounded-lg p-6">
        <div className="animate-pulse space-y-3">
          <div className="h-6 bg-gray-200 rounded w-40 mb-4"></div>

          {[...Array(6)].map((_, i) => (
            <div key={i} className="h-10 bg-gray-200 rounded"></div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white border rounded-lg overflow-hidden">

      <div className="overflow-x-auto">

        <table className="w-full text-sm text-start">

          <thead className="bg-gray-50">
            <tr>
              <th className="p-3 text-left font-semibold text-gray-600">Employee</th>
              <th className="p-3 text-left font-semibold text-gray-600">Date</th>
              <th className="p-3 text-left font-semibold text-gray-600">Status</th>
              <th className="p-3 text-left font-semibold text-gray-600">Check In</th>
              <th className="p-3 text-left font-semibold text-gray-600">Check Out</th>
              <th className="p-3 text-left font-semibold text-gray-600">Late</th>
              <th className="p-3 text-left font-semibold text-gray-600">Early Leave</th>
            </tr>
          </thead>

          <tbody>

            {data.length ? (
              data.map((row) => (
                <tr key={row.id} className="border-t hover:bg-gray-50">

                  <td className="p-3 font-medium text-gray-900">
                    {row.name}
                  </td>

                  <td className="p-3 text-gray-600">
                    {new Date(row.date).toLocaleDateString()}
                  </td>

                  {/* STATUS (Only Absent shown) */}
                  <td className="p-3">
                    {row.status !== "Present" && (
                      <span className="px-2 py-1 text-xs font-semibold bg-red-100 text-red-700 rounded">
                        Absent
                      </span>
                    )}
                  </td>

                  <td className="p-3 text-gray-600">
                    {row.checkin || "-"}
                  </td>

                  <td className="p-3 text-gray-600">
                    {row.checkout || "-"}
                  </td>

                  {/* LATE */}
                  <td className="p-3">
                    {row.late_minutes > 0 && (
                      <span className="text-orange-600 font-medium">
                        {row.late_minutes} min
                      </span>
                    )}
                  </td>

                  {/* EARLY */}
                  <td className="p-3">
                    {row.early_minutes > 0 && (
                      <span className="text-red-600 font-medium">
                        {row.early_minutes} min
                      </span>
                    )}
                  </td>

                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="7"
                  className="text-center p-6 text-gray-400"
                >
                  No attendance records found
                </td>
              </tr>
            )}

          </tbody>

        </table>

      </div>

    </div>
  );
};

export default AttendanceTable;